export enum Audience {
  ENTERPRISE = 'wcp',
  OPEN_DEVELOPER = 'open-developer',
}

export const AudienceDisplay: Record<Audience, string> = {
  [Audience.ENTERPRISE]: 'Enterprise',
  [Audience.OPEN_DEVELOPER]: 'Open Developer',
};
